module.exports = __webpack_public_path__ + "static/media/datos electorales_b-01.7c6b5332.svg";